// extracted by mini-css-extract-plugin
export var phone = "_2t-0";
export var phoneDragging = "_2t-1";